import { ConfigProvider } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export default function ThemeProvider({
  children,
}: {
  children: Readonly<ReactNode>;
}) {
  const { i18n } = useTranslation();

  return (
    <ConfigProvider
      direction={i18n.dir()}
      theme={{
        token: {
          fontFamily:
            i18n.dir() === "rtl" ? "Hacen-Liner-Screen" : "satoshi-variable",
          colorPrimary: "#2A7DE1",
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
